/* "Vilken norm är du?" (snippets/wordup-quiz.liquid): a short intro, then one situation at a time (the answers in a
   new random order each time, so the pattern does not show), a step back is always possible. The law picked most
   often wins; a tie goes to the one picked in the last question, otherwise the one picked first. The result shows
   the shirt, how the answers added up, and a share button. */
(function () {
  var dialog = document.querySelector('[data-quiz]');
  if (!dialog) return;
  var data = JSON.parse(dialog.querySelector('[data-quiz-data]').textContent);
  var body = dialog.querySelector('[data-quiz-body]');
  var progress = dialog.querySelector('[data-quiz-progress]');
  var T = data.text;
  var total = data.questions.length;
  var answers = [];

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) {
      if (k === 'text') node.textContent = attrs[k];
      else node.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) { if (c) node.appendChild(c); });
    return node;
  }

  function shuffled(list) {
    var copy = list.slice();
    for (var i = copy.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = copy[i]; copy[i] = copy[j]; copy[j] = t;
    }
    return copy;
  }

  // Thin segments over the content: filled up to the current question.
  function setProgress(done) {
    progress.replaceChildren.apply(progress, data.questions.map(function (_, i) {
      return el('span', { class: 'wu-quiz__seg' + (i < done ? ' is-done' : '') });
    }));
    progress.hidden = done < 0;
  }

  function show(nodes, focusSelector) {
    body.replaceChildren.apply(body, nodes);
    body.classList.remove('is-in');
    void body.offsetWidth;
    body.classList.add('is-in');
    var target = focusSelector && body.querySelector(focusSelector);
    if (target) target.focus({ preventScroll: true });
  }

  function intro() {
    answers = [];
    dialog.dataset.stage = 'intro';
    setProgress(-1);
    var start = el('button', { type: 'button', class: 'wu-quiz__start', text: T.start + ' →' });
    start.addEventListener('click', function () { question(0); });
    show([
      el('p', { class: 'wu-quiz__q', text: T.intro }),
      start
    ], '.wu-quiz__start');
  }

  function question(i) {
    var q = data.questions[i];
    answers.length = i;
    dialog.dataset.stage = 'q';
    setProgress(i);
    var list = el('div', { class: 'wu-quiz__answers' }, shuffled(q.a).map(function (a) {
      var b = el('button', { type: 'button', class: 'wu-quiz__answer', text: a[0] });
      b.addEventListener('click', function () {
        answers[i] = a[1];
        if (i + 1 < total) question(i + 1); else result();
      });
      return b;
    }));
    var head = el('div', { class: 'wu-quiz__head' }, [el('p', { class: 'wu-quiz__step', text: (i + 1) + ' ' + T.of + ' ' + total })]);
    if (i > 0) {
      var back = el('button', { type: 'button', class: 'wu-quiz__back', text: '← ' + T.back });
      back.addEventListener('click', function () { question(i - 1); });
      head.appendChild(back);
    }
    show([head, el('p', { class: 'wu-quiz__q', text: q.q }), list], '.wu-quiz__answer');
  }

  function winner() {
    var count = {};
    data.order.forEach(function (k) { count[k] = 0; });
    answers.forEach(function (k) { count[k] += 1; });
    var top = Math.max.apply(null, data.order.map(function (k) { return count[k]; }));
    var tied = data.order.filter(function (k) { return count[k] === top; });
    var last = answers[answers.length - 1];
    var best = tied.indexOf(last) > -1 ? last : answers.filter(function (k) { return tied.indexOf(k) > -1; })[0];
    return { best: best, count: count };
  }

  function result() {
    dialog.dataset.stage = 'result';
    setProgress(total);
    var w = winner();
    var r = data.results[w.best];

    var share = el('button', { type: 'button', class: 'wu-quiz__share', text: T.share });
    share.addEventListener('click', function () {
      var url = new URL(r.url, window.location.origin).toString();
      var text = T.result + ' ' + r.name + '. ' + r.line;
      if (navigator.share) {
        navigator.share({ title: r.name, text: text, url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(text + ' ' + url).then(function () { share.textContent = T.copied; });
      }
    });
    var again = el('button', { type: 'button', class: 'wu-quiz__again', text: T.again });
    again.addEventListener('click', function () { question(0); });

    // How the answers added up, the winner first.
    var rows = data.order.slice().sort(function (a, b) {
      return (b === w.best) - (a === w.best) || w.count[b] - w.count[a];
    }).map(function (k) {
      var bar = el('span', { class: 'wu-quiz__fill' });
      bar.style.width = (w.count[k] / total) * 100 + '%';
      return el('li', { class: 'wu-quiz__row' + (k === w.best ? ' is-best' : '') }, [
        el('span', { class: 'wu-quiz__row-name', text: data.results[k].name }),
        el('span', { class: 'wu-quiz__track' }, [bar]),
        el('span', { class: 'wu-quiz__row-n', text: w.count[k] + '/' + total })
      ]);
    });

    show([
      el('p', { class: 'wu-quiz__step', text: T.result }),
      el('p', { class: 'wu-quiz__name', text: r.name }),
      el('p', { class: 'wu-quiz__line', text: r.line }),
      el('a', { class: 'wu-quiz__shirt', href: r.url }, [
        el('span', { class: 'wu-quiz__plate' }, [el('img', { src: r.img, alt: r.law, loading: 'lazy' })]),
        el('span', { class: 'wu-quiz__law' }, [
          el('span', { class: 'wu-quiz__law-label', text: T.law }),
          el('span', { class: 'wu-quiz__law-text', text: r.law })
        ])
      ]),
      el('p', { class: 'wu-quiz__step wu-quiz__spread-label', text: T.spread }),
      el('ul', { class: 'wu-quiz__spread', role: 'list' }, rows),
      el('div', { class: 'wu-quiz__actions' }, [el('a', { class: 'wu-quiz__see', href: r.url, text: r.cta + ' →' }), share, again])
    ], '.wu-quiz__see');
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-quiz-open]')) {
      intro();
      if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', '');
    } else if (event.target.closest('[data-quiz-close]') || event.target === dialog) {
      dialog.close();
    }
  });
})();
